import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

import WithRender from './FicheRepondantAvailableCasSpecialRow.html'

import {
  MIcon,
  MPanel
} from '@ulaval/modul-components'

import LocationSvg from '@/modules/global/media/svg/location/LocationSvg'

import { ICasSpecialRepondant } from '../CasSpecialRepondant.model'
import EventBus from '@/EventBus'

export enum FicheRepondantAvailableCasSpecialRow_EVENTS {
  ITEM_SELECTED = 'item:selected'
}

export interface IFicheRepondantAvailableCasSpecialRowItemSelectedEventPayload {
  casSpecial: ICasSpecialRepondant;
  isSelected: boolean;
}

@WithRender
@Component({
  components: {
    LocationSvg,
    MIcon,
    MPanel
  }
})
export default class FicheRepondantAvailableCasSpecialRow extends mixins() {
  private isSelected: boolean = false 

  @Prop({ required: true })
  private casSpecial!: ICasSpecialRepondant

  private get panelClasses(): object {
    return {
      'fiche-repondant-available-cas-special-row--selected': this.isSelected
    }
  }

  private onPanelClick(): void {
    this.isSelected = !this.isSelected

    EventBus.$emit(FicheRepondantAvailableCasSpecialRow_EVENTS.ITEM_SELECTED, {
      casSpecial: this.casSpecial,
      isSelected: this.isSelected
    } as IFicheRepondantAvailableCasSpecialRowItemSelectedEventPayload)
  }
}
